import React, {useEffect, useState,useRef } from 'react';
import { connect } from 'react-redux';
import InYourAreaHolder from './InYourAreaStyles';
import queryString from 'query-string'; 
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { getNewUrl, getLabel, normalizeForSearch } from "../../utils";
import SEO from '../../components/SEO/SEO';
import InYourAreaSat from "./InYourAreaSat";

const InYourArea = (props)=> {
	const completeUrl = window.location.search; 
	const params = queryString.parse(completeUrl); 
	const [pageData, setPageData] = useState(null);
	const [title, setTitle] = useState([]);
	const [searchRules, setSearchRules] = useState([]);
	const [searchValue, setSearchValue] = useState(params.loc ? params.loc : '');
	const searchInput = useRef(null);
	const searchInputH = useRef(null);
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const siteTitle = " | CPAC.ca";
	const pageURL = window.location.origin + window.location.pathname;
	const [desc, setDesc] = useState('');
	

	useEffect(() => {
		props.url && getApiResults()
	}, [props.url]);

	

	const getApiResults = () => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

		if (searchRules.length === 0 && props.type === '/page/in-your-area') {
			httpGet(serviceUrl, {url:  props.url, crafterSite:craftConf.site}).subscribe((data) => {
				let dataPage = data.page;
				setPageData(dataPage);
				let rules = JSON.parse(dataPage.searchRules);
				//file json elements is in the searchRules variable
				setSearchRules(rules);
			});
		} 

	}

	useEffect(() => { 
		if(pageData) { 
			
			if(props.current_lang === "en"){
				setTitle(pageData.title_en_t);
				setDesc("Find CPAC in Your Area");
			} else {
				setTitle(pageData.title_fr_t);
				setDesc("CPAC dans votre ville");
			}
			window.scrollTo(0, 0);
		}
		
	}, [props.current_lang, pageData]);

	const handleKeyPress = e => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			if(searchInputH.current) {
				submitSearch();
			} else {
				pageSubmitSearch();
			}
		}
	}

	const submitSearch = () => {
		const urlStr = window.location;
		const url = new URL(urlStr);
		const tempUrl = getNewUrl(props.urlMap, props.contentType, url.search, props.current_lang === 'en' ? 'fr' : 'en');
		url.searchParams.set("loc", searchValue);
		window.location.href = `${tempUrl}${url.search}`;
		setSearchValue(searchValue);
	}

	const pageSubmitSearch = () => {
		setSearchValue(searchInput.current.value);
		window.history.replaceState({}, document.title, getNewUrl(props.urlMap, props.contentType, '', props.current_lang === 'en' ? 'fr' : 'en'));
		getApiResults();
	}

	const channelEnglish = (channel) => {
		return (
			<> 
				<dl className="channel-en" tabIndex="0">
					{channel &&
						<dt className="inarea-text" tabIndex="0">{getLabel("ENGLISH")}<span className="inarea-channel">{channel}</span></dt>
					}
				</dl>   
			</>
		);
	}

	
	const channelFrench = (channel) => {
		return (
			<>
				<dl className="channel-fr" tabIndex="0">
					{channel &&
						<dt className="inarea-text" tabIndex="0">{getLabel("FRENCH")}<span className="inarea-channel">{channel}</span></dt>
					}
				</dl>
			</>
		);
	}
/*
	const provinceAvailability = (props, prov) => {
		if (props.current_lang === 'en'){
			return "Available across ";
		} else {
			if (prov === 'Manitoba' || prov === 'Québec' || prov === 'New Brunswick' || prov === 'Nunavut' || prov === 'Yukon') {
				return "Disponible partout au ";
			} else if (prov === 'Prince Edward Island' || prov === 'Newfoundland and Labrador'){
				return "Disponible partout à ";
			} else if (prov === 'Northwest Territories'){
				return "Disponible partout dans les ";
			} else {
				return "Disponible partout en ";
			}
		}
	} 
	*/
	const renderInYourAreaPage = () => {
				
		return (
			<>
			<SEO pageDesc={desc} pageURL={pageURL} title={title} pageTitle={title + siteTitle} robots="false" pageLocale={pageLocale} />
			<InYourAreaHolder>
				<div className="inYourArea__container" itemScope itemType='https://schema.org/SearchResultsPage'>
					<h1 className="page-title" tabIndex="0" itemProp='headline'>{title}</h1>
					<section className="inyour-area-content" itemProp='mainEntity'>
						<article className="inyour-area-page">
							<div className="inyour-area-bar">
								<input
									className="cpac-area-input"
									placeholder={getLabel("CITY")}
									aria-label={getLabel("CITY")}
									ref={searchInput}
									onKeyPress={(e)=>handleKeyPress(e)} />
								<button className="btn-cityFind" onClick={ () => { pageSubmitSearch() } }>{getLabel("FIND")}</button>
							</div>
							<section className="inyour-area-search-results" tabIndex="0">					
								{searchRules && searchRules.response && searchRules.response.filter((rule) => {
									
									if (rule.community !== null && typeof rule.community === 'string') {
										rule.community = normalizeForSearch(rule.community);
									}
									return rule.community === normalizeForSearch(searchValue);
									
								}).map((rule) => {
										
									return <div key={rule.provinceEn} itemScope itemType='https://schema.org/ItemList'>
									<div className="inyour-area-community" tabIndex="0">
									<span className="community-label">{searchValue && getLabel("RESULTS_FOR")}</span> <span className="community-name">{searchValue && searchValue !== '' ? searchValue + ', ' : ''}{props.current_lang && props.current_lang === 'en' ? rule.provinceEn : rule.provinceFr}</span>
									</div>
									{rule.children.map((child) => {
										
										return 	<div className="company-item col" tabIndex="0" key={child.BDU} itemProp='itemListElement'>
													<div>
														<h2 className="company-name" tabIndex="0">{child.BDU}</h2>
														{props.current_lang && props.current_lang === 'en' ? channelEnglish(child.channelEn) : channelFrench(child.channelFr)}
														{props.current_lang && props.current_lang === 'en' ? channelFrench(child.channelFr) : channelEnglish(child.channelEn)}
													</div>
												</div>
											})}	
									</div>		
									
									})
								}
								
							</section>
							<InYourAreaSat lang={props.current_lang}/>
						</article>
					</section>
				</div>
			</InYourAreaHolder>
			</>
		)
	}

	const renderHomePage = () => {
		return (
			<InYourAreaHolder>
				<div className="home__container">
					<div className="inyour-area-bar">
						<input className="cpac-area-input"
							placeholder={getLabel("CPACCITY")} 
							value={ searchValue } 
							ref={searchInputH}
							onChange={ (e) => setSearchValue(e.target.value) } 
							onKeyPress={ (e)=> handleKeyPress(e) } />
						<button className="btn-cityFind" onClick={ () => { submitSearch() } } >
							{getLabel("FIND")}
						</button>
					</div>
				</div>
			</InYourAreaHolder>
		)
	}

	return (
		<>
			{props.type && props.type === "/page/in-your-area" && renderInYourAreaPage()}
			{/* {props.type && props.type !== "/page/in-your-area" && renderHomePage()} */}
		</>
	)

}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
	urlMap: store.urlMap,
});

export default connect(mapStateToProps,null)(InYourArea);